import isObject from 'lodash/isObject';

/**
 * Converts capabilities object to an array of capability values.
 * Returns empty array if input is not a valid object.
 * @param {Object|*} capabilitiesAsObject - Object with capability UUIDs as keys.
 * @returns {Array<Object>} Array of capability objects.
 * @example
 * const capabilities = {
 *   'uuid-1': { capability_name: 'switch', read_write: '1' },
 *   'uuid-2': { capability_name: 'dimmer', read_write: '1' },
 * };
 * getCapabilityListAsArray(capabilities);
 * // Returns [{ capability_name: 'switch', ... }, { capability_name: 'dimmer', ... }]
 * @example
 * getCapabilityListAsArray(null); // Returns []
 * getCapabilityListAsArray(undefined); // Returns []
 */
export const getCapabilityListAsArray = (capabilitiesAsObject) => {
    if (!isObject(capabilitiesAsObject)) {
        return [];
    }

    return Object.values(capabilitiesAsObject) || [];
};
